<span class="text-primary" (click)="maskToggle()">
  {{ displayContent }}
  <ng-container *ngIf="contentMask">
    <i class="text-primary" [faIcon]="fas.faChevronUp"> </i>
  </ng-container>
  <ng-container *ngIf="!contentMask && toggleMask">
    <i class="text-primary" [faIcon]="fas.faChevronDown"> </i>
  </ng-container>
</span>
